const fallback = (context: Element, node: (Node & ParentNode) | null) => {
  if (!node) return false;

  do {
    if (node === context) {
      return true;
    }
  } while (node.parentNode && (node = node.parentNode));

  return false;
};

/**
 * 判断一个元素是否包含在另一个元素中
 * 
 * 该函数通过多种方式尝试判断元素是否包含在另一个元素中，首先尝试使用 Element.contains 方法，
 * 如果不可用，则尝试使用 compareDocumentPosition 方法。如果这两种方法都不可用，则回退到
 * 一个指定的 fallback 函数
 * 
 * @param context 要检查的父元素
 * @param node 要检查是否被包含的子元素
 * @returns 如果 node 被 context 包含，则返回 true；否则返回 false
 */
export const contains = (context: Element, node: (Node & ParentNode) | null) => {
  // 如果 node 为空，则直接返回 false
  if (!node) return false;

  // 如果 context 具有 contains 方法，则直接使用该方法判断
  if (context.contains) {
    return context.contains(node);
  }
  // 如果 context 具有 compareDocumentPosition 方法，则使用该方法判断
  else if (context.compareDocumentPosition) {
    // 如果 context 和 node 相等，或者通过 compareDocumentPosition 判断 node 包含 context，则返回 true
    return context === node || !!(context.compareDocumentPosition(node) & 16);
  }

  // 如果以上两种方法都不适用，则调用 fallback 函数进行判断
  return fallback(context, node);
};